import { PLATFORM_ACCESS, USER_TYPE_SHOPADMIN, USER_TYPE_TECHNICIAN } from "src/config-global";
import { paths } from "src/routes/paths";

// Only an explicit `false` forces the terms step. Accounts created before the
// feature have no `accepted_terms` field at all and must not be blocked.
export const requiresTermsAcceptance = (account) => account?.accepted_terms === false;

export const createPathAfterLogin = (user) => {
    let platformAccess;
    if(user?.user_type === USER_TYPE_TECHNICIAN && user.contractor) {
      platformAccess = user?.contractor?.platform_access || ['support_center']; 
    }else{
      platformAccess = user?.platform_access || ['support_center']; 
    }
   // Default to support_center if platform_access is not defined  
    const isCustomerHubUser = platformAccess.includes(PLATFORM_ACCESS.CUSTOMER_HUB);  
    const isTrainingAcademyUser = platformAccess.includes(PLATFORM_ACCESS.TRAINING_ACADEMY);  
    const isSupportCenterUser = platformAccess.includes(PLATFORM_ACCESS.SUPPORT_CENTER);
    const isShopAdminUser = user?.user_type===USER_TYPE_SHOPADMIN;
    const isAssignedBuild = Boolean(user?.is_assigned_build);
    
    if(isShopAdminUser){
      return paths.shopAdminDashboard.root
    } else if(isCustomerHubUser && isAssignedBuild){
      return paths.dashboard.buildMode.buildList
    } else if(isCustomerHubUser) {
      return paths.dashboard.root;
    } else if (isTrainingAcademyUser) {
      return paths.dashboard.trainingAcademy.root
    } else if (isSupportCenterUser) {
      return paths.dashboard.supportCenter
    } else{
      return paths.dashboard.root; 
    }
};